import { ReactNode, useLayoutEffect, useRef } from "react";

interface BillingReportCaptureProps {
  children: ReactNode;
}

interface BillingReportRenderWindow extends Window {
  reportHtmlCapture?: string;
}

export function BillingReportCapture({ children }: BillingReportCaptureProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const reportElement = containerRef.current?.firstElementChild;
    if (!reportElement) return;
    const renderWindow = window as BillingReportRenderWindow;
    renderWindow.reportHtmlCapture =
      buildSelfContainedReportHtml(reportElement);
    reportElement.setAttribute("data-billing-report-render-complete", "true");
    return () => {
      delete renderWindow.reportHtmlCapture;
    };
  }, []);

  return (
    <div ref={containerRef} style={{ display: "contents" }}>
      {children}
    </div>
  );
}

function buildSelfContainedReportHtml(reportElement: Element): string {
  const css = Array.from(document.styleSheets)
    .flatMap((sheet) => {
      try {
        return Array.from(sheet.cssRules).map((rule) => rule.cssText);
      } catch {
        return [];
      }
    })
    .join("\n");
  return [
    "<!doctype html><html><head>",
    '<meta charset="utf-8">',
    `<style>${css}</style>`,
    "</head><body>",
    reportElement.outerHTML,
    "</body></html>",
  ].join("");
}
